/**
 * The ready rooms' projects (`src/state/roomShapes/*.xml`), each a small file of its own fetched on first use; a picker
 * warms them up as it opens (`prefetchRoomShapes`) so a choice rarely waits. They are fetched as files, not imported as
 * modules: the browser keeps a module that failed to load failed for the page's life, while a failed fetch is simply
 * forgotten here, and the next choice tries again.
 */
import type { RoomShapeId } from '../state/roomShapes';

// Read on first use: the build fills the call in, while the node tests that load the editor's modules never reach it.
let urls: Record<string, string> | undefined;
const shapeUrls = () => urls ??= import.meta.glob('../state/roomShapes/*.xml', { query: '?url', import: 'default', eager: true }) as Record<string, string>;
const loaded = new Map<RoomShapeId, Promise<string>>();

export function loadRoomShape(id: RoomShapeId): Promise<string> {
  let pending = loaded.get(id);
  if (!pending) {
    const url = shapeUrls()[`../state/roomShapes/${id}.xml`];
    pending = url ? fetch(url).then(response => { if (!response.ok) throw new Error(`${id}: ${response.status}`); return response.text(); })
      : Promise.reject(new Error(`no room shape ${id}`));
    const mine = pending;
    mine.catch(() => { if (loaded.get(id) === mine) loaded.delete(id); });
    loaded.set(id, pending);
  }
  return pending;
}

export function prefetchRoomShapes(ids: readonly RoomShapeId[]): void {
  for (const id of ids) loadRoomShape(id).catch(() => { /* tried again when chosen */ });
}
